export default __webpack_public_path__ + "static/media/fontRoboto700_vietnamese.3425a701.woff2";